import React from 'react';

import {
  GridColumnVisibilityModel,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid';
import Stack from '@mui/material/Stack';

import { dashboardService } from 'pages/Dashboard';
import { FACEBOOK_DATA_SOURCE } from 'pages/Dashboard/utils/constants';
import GraphData from 'pages/Dashboard/models/GraphData';
import FBAdsManagerButton from 'pages/Dashboard/components/dataTable/toolbar/FBAdsManagerButton';
import GraphButton from 'pages/Dashboard/components/graph/GraphButton';
import OrderTableColumns from 'pages/Dashboard/components/dataTable/OrderTableColumns';
import PerformanceData from 'pages/Dashboard/models/PerformanceData';

interface TableToolbarProps {
  metricsData: PerformanceData[];
  selectionModel: string[];
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnOrderChange: (columns: GridColumnVisibilityModel) => void;
  getGraphData: () => Promise<GraphData>;
}

function TableToolbar({
  metricsData,
  selectionModel,
  columnVisibilityModel,
  onColumnOrderChange,
  getGraphData,
}: TableToolbarProps) {
  const dataSource = dashboardService.dataSource;

  return (
    <GridToolbarContainer>
      <Stack direction={'row'} spacing={1} sx={{ mt: 1.5, ml: 0.5 }}>
        <GridToolbarExport />
        <OrderTableColumns
          columnVisibilityModel={columnVisibilityModel}
          onColumnOrderChange={onColumnOrderChange}
        />
        {dataSource === FACEBOOK_DATA_SOURCE && (
          <GraphButton
            getGraphData={getGraphData}
            metrics={metricsData}
            selected={selectionModel}
          />
        )}
        {dataSource === FACEBOOK_DATA_SOURCE && (
          <FBAdsManagerButton metrics={metricsData} selected={selectionModel} />
        )}
      </Stack>
    </GridToolbarContainer>
  );
}

export default TableToolbar;
